<template lang="pug">
div
  .form
    p Personaliseer je aanvraagpagina door je eigen logo en achtergrond te uploaden. Je klanten komen dan in een bekende en vertrouwde omgeving.

    div
      h4 Terugkeer pagina
      p Hier wordt een gebruiker naar doorgestuurd nadat het formulier is ingevuld.
      text-field.pa-0(
        v-model='successUrl',
        placeholder='https://www.mijnwebsite.com/bedankt-voor-je-aanvraag',
        :error-messages='successUrlValidationErrors',
        @change='$v.successUrl.$touch()',
        @blur='$v.successUrl.$touch()'
        )

    v-divider

  v-switch(label='Gebruik organisatie stijl', v-model='useOrganizationFormStyleModel', color='primary')

  div(:class='{ hidden: useOrganizationFormStyle }')
    FormStyle(
      :primaryColor.sync='primaryColor',
      :backgroundColor.sync='backgroundColor',
      :logo.sync='logoUrl',
      :logoPreview.sync='logoPreview',
      :backgroundImage.sync='backgroundImageUrl',
      :backgroundImagePreview.sync='backgroundImagePreview'
      )

    //- PictureInput.hidden(
    //-   ref='pictureInput'
    //-   )

    h2 Voorbeeld aanvraagpagina
    .example-form
      iframe(ref='iframe', :src='testFormUrl')
</template>

<script>
import { url } from 'vuelidate/lib/validators'

export default {
  props: {
    value: Object,
    useOrganizationFormStyle: Boolean
  },

  components: {
    FormStyle: require('@/components/FormStyle').default
  },

  data () {
    return {
      data: this.value,
      successUrl: null,
      website: {},
      primaryColor: '#00b333',
      backgroundColor: '#E0E0E0',
      logoUrl: null,
      logoPreview: null,
      backgroundImageUrl: null,
      backgroundImagePreview: null,

      useOrganizationFormStyleModel: this.useOrganizationFormStyle
    }
  },

  computed: {
    isNew () {
      return this.$route.params.websiteId === 'new'
    },

    testFormUrl () {
      const image = 'https://portal-test.dealerfinanceservices.nl/images/example-car.jpg'
      const title = 'BMW-4'

      const urlType = this.type === 'private' ? 'particulier' : 'zakelijk'

      const domain = 'example.com'

      return `${process.env.VUE_APP_FORM_DOMAIN}/lease/${urlType}?domain=${domain}&pv=10000&fv=2000&nper=60&deposit=1000&title=${title}&image=${image}`
    },

    successUrlValidationErrors () {
      const errors = []
      if (!this.$v.successUrl.$dirty) return errors
      !this.$v.successUrl.url && errors.push('Dit moet een geldig URL zijn in deze vorm: https://mijnwebsite.com/bedankt')
      return errors
    }
  },

  methods: {
    setIframeOptions () {
      const msg = {
        primaryColor: this.primaryColor,
        backgroundColor: this.backgroundColor
      }

      if (this.backgroundImagePreview) {
        msg.backgroundImageUrl = this.backgroundImagePreview
      }

      if (this.logoPreview) {
        msg.logoUrl = this.logoPreview
      }

      // if (this.useOrganizationFormStyleModel) { // Maybe implement this later. Quite dirty to do it this way since preloadImage doesnt return a promise.
      //   msg.primaryColor = this.$store.state.organization.current.defaultFormStyle.primaryColor
      //   msg.backgroundColor = this.$store.state.organization.current.defaultFormStyle.backgroundColor

      //   this.$refs.pictureInput.preloadImage(this.$store.state.organization.current.defaultFormStyle.backgroundImageUrl)

      //   console.log(this.$refs.pictureInput.image);
      // }

      if (this.$store.state.organization.current.dataGeneral) {
        msg.title = this.$store.state.organization.current.dataGeneral.companyName
      }

      this.$refs.iframe.contentWindow.postMessage(msg, '*') // TODO check this in production
    },
  },

  watch: {
    value: {
      handler: function (v) {
        this.data = v

        if (v.primaryColor) {
          this.primaryColor = v.primaryColor
        }

        if (v.backgroundColor) {
          this.backgroundColor = v.backgroundColor
        }

        if (v.logoUrl) {
          this.logoUrl = v.logoUrl
        }

        if (v.backgroundImageUrl) {
          this.backgroundImageUrl = v.backgroundImageUrl
        }

        this.successUrl = v.successUrl
      },
      immediate: true
    },

    data: {
      handler: function (v) {
        this.$emit('input', this.data)

        this.setIframeOptions()
      },
      deep: true
    },

    '$v.$invalid': {
      handler: function (v) {
        this.$emit('valid', {
          tab: 'tabDealer',
          valid: !v
        })
      },
      immediate: true
    },

    primaryColor (v) {
      this.$set(this.data, 'primaryColor', v)
    },

    backgroundColor (v) {
      this.$set(this.data, 'backgroundColor', v)
    },

    successUrl (v) {
      this.$set(this.data, 'successUrl', v)
    },

    logoUrl (v) {
      this.$set(this.data, 'logoUrl', v)
    },

    backgroundImageUrl (v) {
      this.$set(this.data, 'backgroundImageUrl', v)
    },

    useOrganizationFormStyleModel (v) {
      this.$emit('update:useOrganizationFormStyle', v)

      this.setIframeOptions()
    }
  },

  mounted () {
    this.$refs.iframe.onload = () => {
      setTimeout(() => {
        this.setIframeOptions()
      }, 2000) // TODO should be after logo & background is done loading
    }
  },

  validations: {
    successUrl: {
      url
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/responsive.scss";

.example-form {
  margin-bottom: 620px;

  iframe {
    $scale: 0.5;

    width: 90% / $scale;
    height: 600px / $scale;
    transform: scale($scale);
    transform-origin: 0 0;
    position: absolute;
    pointer-events: none;
  }
}
</style>
